import { map, filter, uniqBy, set } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import {
  Friend,
  Gallery,
  Profile,
  UserPost,
  Follower,
  UserData,
  CreditCard,
  UserInvoice,
  UserManager,
  UserAddressBook,
  NotificationSettings
} from '../../@types/user';
// 平台資源庫
import { search, getAISearch } from '../../api/platform';
// 貼堂區
import {
  getHighlightList,
  recordAddLike,
  getHighlightCommentList,
  setHighlightCommentadd,
  deleteHighlightComment,
  setHighlightCommentupdate
} from '../../api/Showcase';

import { uploadProfile, updatePassword } from 'api/user';
import { clear } from 'console';

// ----------------------------------------------------------------------

type UserState = {
  isLoading: boolean;
  error: boolean;
  myProfile: null | Profile;
  posts: UserPost[];
  users: UserData[];
  userList: UserManager[];
  followers: Follower[];
  friends: Friend[];
  gallery: Gallery[];
  cards: CreditCard[] | null;
  addressBook: UserAddressBook[];
  invoices: UserInvoice[];
  notifications: NotificationSettings | null;
  search: any[];
  Showcase: [];
  total: null;
  amount: 0;
  CommentList: [];
  password: any;
  detailLoading: boolean;
  detailInfo: null;
  isLoadingSearch: boolean;
  isLoadingAIsearch: boolean;
  AIsearch: any[];
  resourceExtra: any;
};

const initialState: UserState = {
  isLoading: false,
  error: false,
  myProfile: null,
  posts: [],
  users: [],
  userList: [],
  followers: [],
  friends: [],
  gallery: [],
  cards: null,
  addressBook: [],
  invoices: [],
  notifications: null,
  search: [],
  AIsearch: [],
  Showcase: [],
  total: null,
  amount: 0,
  CommentList: [],
  password: '',
  detailLoading: false,
  detailInfo: null,
  isLoadingSearch: false,
  isLoadingAIsearch: false,
  resourceExtra: null
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.isLoadingSearch = false;
      state.isLoadingAIsearch = false;
      state.error = action.payload;
    },

    // GET PROFILE
    getProfileSuccess(state, action) {
      state.isLoading = false;
      state.myProfile = action.payload;
    },

    // GET POSTS
    getPostsSuccess(state, action) {
      state.isLoading = false;
      state.posts = action.payload;
    },

    // GET USERS
    getUsersSuccess(state, action) {
      state.isLoading = false;
      state.users = action.payload;
    },

    // DELETE USERS
    deleteUser(state, action) {
      const deleteUser = filter(state.userList, (user) => user.id !== action.payload);
      state.userList = deleteUser;
    },

    // GET FOLLOWERS
    getFollowersSuccess(state, action) {
      state.isLoading = false;
      state.followers = action.payload;
    },

    // ON TOGGLE FOLLOW
    onToggleFollow(state, action) {
      const followerId = action.payload;

      const handleToggle = map(state.followers, (follower) => {
        if (follower.id === followerId) {
          return {
            ...follower,
            isFollowed: !follower.isFollowed
          };
        }
        return follower;
      });

      state.followers = handleToggle;
    },

    // GET FRIENDS
    getFriendsSuccess(state, action) {
      state.isLoading = false;
      state.friends = action.payload;
    },

    // GET GALLERY
    getGallerySuccess(state, action) {
      state.isLoading = false;
      state.gallery = action.payload;
    },

    // GET MANAGE USERS
    getUserListSuccess(state, action) {
      state.isLoading = false;
      state.userList = action.payload;
    },

    // GET CARDS
    getCardsSuccess(state, action) {
      state.isLoading = false;
      state.cards = action.payload;
    },

    // GET ADDRESS BOOK
    getAddressBookSuccess(state, action) {
      state.isLoading = false;
      state.addressBook = action.payload;
    },

    // GET INVOICES
    getInvoicesSuccess(state, action) {
      state.isLoading = false;
      state.invoices = action.payload;
    },

    // GET NOTIFICATIONS
    getNotificationsSuccess(state, action) {
      state.isLoading = false;
      state.notifications = action.payload;
    },

    // 平台資源庫
    getsearch(state, { payload }) {
      state.isLoadingSearch = false;
      if (payload.rows.length > 0) {
        const isRepeat = uniqBy([...state.search, ...payload.rows], 'id');
        state.search = isRepeat;
        state.total = payload.total;
      }
    },
    setAIsearch(state, { payload }) {
      state.isLoadingAIsearch = false;
      if (payload.rows.length > 0) {
        const isRepeat = uniqBy([...state.AIsearch, ...payload.rows], 'id');
        state.AIsearch = isRepeat;
        state.total = payload.total;
      }
    },
    getInitialsearch(state, { payload }) {
      state.isLoadingSearch = false;
      state.search = payload.rows;
      state.total = payload.total;
    },
    getInitialAIsearch(state, { payload }) {
      state.isLoadingAIsearch = false;
      state.AIsearch = payload.rows;
      state.total = payload.total;
    },
    setResourceExtra(state, { payload }) {
      state.resourceExtra = payload;
    },
    // 貼堂區
    gethighlight(state, action) {
      state.isLoading = false;
      state.Showcase = action.payload.rows;
      state.amount = action.payload.total;
    },
    // 貼堂區留言列表
    getCommentList(state, action) {
      state.isLoading = false;
      state.CommentList = action.payload;
    },
    // 預設背景圖片為頭像
    updateAvatarSuccess(state) {
      state.isLoading = false;
    },
    // 更改用戶登錄密碼
    updatePasswordSuccess(state, action) {
      state.isLoading = false;
      state.password = action.payload;
    },
    // 打開評論詳情頁的loading
    setDetailLoading(state, action) {
      state.detailLoading = action.payload;
    },
    setDetailInfo(state, action) {
      state.detailInfo = action.payload;
      state.detailLoading = false;
    },
    setLoadingSearch(state) {
      state.isLoadingSearch = true;
    },
    setLoadingAIsearch(state) {
      state.isLoadingAIsearch = true;
    },
    clearSearch(state) {
      state.search = [];
    },
    clearAIsearch(state) {
      state.AIsearch = [];
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  onToggleFollow,
  deleteUser,
  setDetailInfo,
  getCommentList,
  setDetailLoading,
  setLoadingAIsearch,
  clearSearch,
  clearAIsearch,
  setResourceExtra
} = slice.actions;

// ----------------------------------------------------------------------

export function getProfile() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/profile');
      dispatch(slice.actions.getProfileSuccess(response.data.profile));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getPosts() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/posts');
      dispatch(slice.actions.getPostsSuccess(response.data.posts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFollowers() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/social/followers');
      dispatch(slice.actions.getFollowersSuccess(response.data.followers));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFriends() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/social/friends');
      dispatch(slice.actions.getFriendsSuccess(response.data.friends));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getGallery() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/social/gallery');
      dispatch(slice.actions.getGallerySuccess(response.data.gallery));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getUserList() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/manage-users');
      dispatch(slice.actions.getUserListSuccess(response.data.users));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getCards() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/cards');
      dispatch(slice.actions.getCardsSuccess(response.data.cards));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getAddressBook() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/address-book');
      dispatch(slice.actions.getAddressBookSuccess(response.data.addressBook));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getInvoices() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/invoices');
      dispatch(slice.actions.getInvoicesSuccess(response.data.invoices));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getNotifications() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/notifications-settings');
      dispatch(slice.actions.getNotificationsSuccess(response.data.notifications));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getUsers() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/all');
      dispatch(slice.actions.getUsersSuccess(response.data.users));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// 平台資源庫
export function getsearchAction(params: any) {
  return async () => {
    dispatch(slice.actions.setLoadingSearch());
    try {
      const response = await search(params);
      dispatch(slice.actions.getsearch(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInitialSearch(params: any) {
  return async () => {
    dispatch(slice.actions.setLoadingSearch());
    try {
      const response = await search(params);
      dispatch(slice.actions.getInitialsearch(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// 貼圖區list
export function getShowcaseList(params: any) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getHighlightList(params);
      dispatch(slice.actions.gethighlight(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// 點讚
export function getAddList(params: any) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await recordAddLike(params);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// 貼堂區留言列表
export function getCommentLists(params: any) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getHighlightCommentList(params);
      dispatch(slice.actions.getCommentList(response.rows));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// 貼堂區留言
export function getCommentadd(params: any) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await setHighlightCommentadd(params);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// 删除留言
export function getCommentDelete(params: any) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await deleteHighlightComment(params);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// 更改留言
export function getCommentupdate(params: any) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await setHighlightCommentupdate(params);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// 更改留言
export function getUploadProfile(_permit: any, file: any) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await uploadProfile(_permit, file);
      return response;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
//修改密碼
export function updatePasswordAction(params: any) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await updatePassword(params);
      const { newPassword } = params;
      dispatch(slice.actions.updatePasswordSuccess(newPassword));
      return response;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// AI 平台资料库
export function fetchAISearch(params: any) {
  return async () => {
    dispatch(slice.actions.setLoadingAIsearch());
    try {
      const { append = false, callback, ...rest } = params;
      const response = await getAISearch(rest);
      if (append) {
        // Append new results to existing list
        dispatch(slice.actions.setAIsearch(response));
      } else {
        // Replace results (initial search)
        dispatch(slice.actions.getInitialAIsearch(response));
      }
      if (callback) {
        callback(response);
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
